import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class WebsocketService {
  private socket!: WebSocket;
  private subject = new Subject<number>();
  private clientId!: string;

  /**
   * Connect to WebSocket server
   * @param url WebSocket server URL
   * @param clientId Unique client identifier
   */
  public async connect(url: string, clientId: string): Promise<void> {
    this.clientId = clientId;
  
    return new Promise((resolve, reject) => {
      this.socket = new WebSocket(url);
  
      this.socket.onopen = () => {
        console.log('WebSocket connected');
        // Optionally send the clientId here
        // this.sendMessage({});
        resolve(); // ✅ Notify successful connection
      };
  
      this.socket.onerror = (err) => {
        console.error('WebSocket error:', err);
        reject(err); // Notify failure
      };
  
      this.socket.onmessage = (event) => {
        const data = JSON.parse(event.data);
        if (data.clientId === this.clientId && data.countdown !== undefined) {
          this.subject.next(data.countdown);
        }
      };
  
      this.socket.onclose = () => {
        console.log('WebSocket disconnected');
      };
    });
  }

  /**
   * Send countdown request with seconds
   * @param seconds The countdown start value
   */
  public sendCountdown(seconds: number): void {
    if (this.socket && this.socket.readyState === WebSocket.OPEN) {
      this.sendMessage({ seconds });
    } else {
      console.error('WebSocket is not connected.');
    }
  }

  /**
   * Generic function to send message including clientId
   */
  private sendMessage(data: Record<string, any>) {
    if (!this.clientId) {
      console.error('clientId is not set.');
      return;
    }
    const payload = {
      clientId: this.clientId,
      ...data,
    };
    this.socket.send(JSON.stringify(payload));
  }

  /**
   * Subscribe to countdown stream
   */
  public onCountdown(): Observable<number> {
    return this.subject.asObservable();
  }

  public close(): void {
    if (this.socket && this.socket.readyState === WebSocket.OPEN) {
      console.log('Closing WebSocket connection');
      this.socket.close();
    }
    this.subject.complete(); // Optional: complete subject if you're fully done
  }
}
